import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const UserFraudStatusRBAC = {
  pageID: '665a3f897bdfc443a8dfd08a6fd40018',
  elementID: {
    ViewFraudStatus: 'a0a104842c6dfff2c6f3a44fd5d1f70e',
    ActionFraud: '764cb55870de2ec6662aa9e4cf6735a8',
    ActionNormal: '17c84df2ed638e1fb67ef572df80012b',
  },
} as const

export const useUserFraudStatusRBACPage = createUseRBAC(UserFraudStatusRBAC.elementID)

export type UseUserFraudStatusRBACPageType = ReturnType<typeof useUserFraudStatusRBACPage>
